export function sanitizeString(str: string): string {
  try {
    return str.toLowerCase().replace(/(?![а-яёА-ЯЁ])[\s\W]/g, '');
  } catch (error) {
    return '';
  }
}
